// actions
import { Commit, ActionTree, Dispatch } from 'vuex';
import { State, Group } from '@/store/modules/apm/topoGroup/topoGroup.store';

import { TopoGroupService } from '@/services/api/topo-group.service';

const actions: ActionTree<State, any> = {
  // Get all group data from the api during the initial loading of the component
  getTopoGroups(context: { commit: Commit; dispatch: Dispatch }) {
    TopoGroupService.getAllGroups()
      .then((res) => {
        if (!res.data) {
          return;
        }
        context.commit('initGroups', res.data);
      })
      .catch((error: any) => {
        console.log('error', error);
      });
  },

  // Create the group in the database and call the mutation on success
  createTopoGroup(
    context: { commit: Commit; dispatch: Dispatch },
    params: {
      // username: string;
    },
  ) {
    TopoGroupService.createGroup(params)
      .then((res) => {
        if (!res.success) {
          return;
        } else {
          context.dispatch('getTopoGroups');
        }
      })
      .catch((error: any) => {
        throw error;
      });
  },
  getServiceByGroup(context: { commit: Commit; dispatch: Dispatch }, params) {
    TopoGroupService.getAppsByGroup(params)
      .then((res) => {
        if (!res.data) {
          return;
        }
        // console.log('services', res.data);
      })
      .catch((error: any) => {
        throw error;
      });
  },
  // Delete the group from the database and call the mutation on success
  deleteGroup(context: { commit: Commit; dispatch: Dispatch }, params) {
    TopoGroupService.deleteGroup(params)
      .then((res) => {
        if (!res.success) {
          return;
        }
        context.commit('deleteGroup', params);
      })
      .catch((error: any) => {
        throw error;
      });
  },
  updateTopoGroup(context: { commit: Commit; dispatch: Dispatch }, params) {
    TopoGroupService.updateGroup(params.id, params.data)
      .then((res) => {
        if (!res.success) {
          return;
        } else {
          context.dispatch('getTopoGroups');
        }
      })
      .catch((error: any) => {
        throw error;
      });
  },
};
export default actions;
